import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pa-8"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", null, "Státusz", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Típus", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Összeg", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, "Fizetve", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Létrehozva", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "Módosítva", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Státusz módosítása", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "Fizetés dátuma", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Számla összege", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return ($setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading..."))
    : ($setup.error)
      ? (_openBlock(), _createBlock($setup["ResourceErrorState"], {
          key: 1,
          kind: $setup.error.kind,
          "trace-id": $setup.error.traceId,
          "back-to": "/admin/bills",
          "back-label": "Vissza a számlákhoz",
          onRetry: $setup.fetchData
        }, null, 8, ["kind", "trace-id"]))
      : (_openBlock(), _createBlock(_component_v_container, {
          key: 2,
          fluid: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(`Számla: ${$setup.bill.identifier}`), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _hoisted_2,
                            _createElementVNode("div", null, [
                              _createVNode(_component_v_chip, {
                                color: $setup.statusColor($setup.bill.status),
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.statusLabel($setup.bill.status)), 1)
                                ]),
                                _: 1
                              }, 8, ["color"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _hoisted_3,
                            _createElementVNode("div", null, [
                              _createVNode(_component_v_chip, {
                                color: $setup.typeColor($setup.bill.type),
                                size: "small",
                                variant: "outlined"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.typeLabel($setup.bill.type)), 1)
                                ]),
                                _: 1
                              }, 8, ["color"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _hoisted_4,
                            _createElementVNode("div", null, _toDisplayString($setup.formatAmount($setup.bill.amount)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _hoisted_5,
                            _createElementVNode("div", null, _toDisplayString($setup.formatDateOnly($setup.bill.paidAt)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _hoisted_6,
                            _createElementVNode("div", null, _toDisplayString($setup.formatDate($setup.bill.createdAt)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _hoisted_7,
                            _createElementVNode("div", null, _toDisplayString($setup.formatDate($setup.bill.updatedAt)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      class: "mt-2",
                      align: "end"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8,
                            _createVNode(_component_v_select, {
                              class: "mt-2",
                              modelValue: $setup.newStatus,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.newStatus) = $event)),
                              items: $setup.statusOptions,
                              "item-title": "label",
                              "item-value": "value",
                              variant: "outlined",
                              density: "compact"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9,
                            _createVNode(_component_v_text_field, {
                              class: "mt-2",
                              modelValue: $setup.newPaidAt,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.newPaidAt) = $event)),
                              type: "date",
                              variant: "outlined",
                              density: "compact",
                              clearable: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10,
                            _createVNode(_component_v_text_field, {
                              class: "mt-2",
                              modelValue: $setup.newAmount,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.newAmount) = $event)),
                              type: "number",
                              suffix: "Ft",
                              variant: "outlined",
                              density: "compact"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              color: "primary",
                              onClick: $setup.saveChanges,
                              disabled: !$setup.hasChanges || $setup.saving,
                              loading: $setup.saving
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Mentés")
                              ]),
                              _: 1
                            }, 8, ["disabled", "loading"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "mt-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Kapcsolódó foglalás elemek")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_data_table, {
                              headers: $setup.attachedHeaders,
                              items: $setup.attachedItems,
                              density: "compact",
                              "no-data-text": "Nincs kapcsolódó foglalás elem"
                            }, {
                              "item.startDate": _withCtx(({ value }) => [
                                _createTextVNode(_toDisplayString(value), 1)
                              ]),
                              "item.endDate": _withCtx(({ value }) => [
                                _createTextVNode(_toDisplayString(value), 1)
                              ]),
                              "item.bookingPublicReference": _withCtx(({ value }) => [
                                value
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      class: "text-decoration-none",
                                      to: `/admin/bookings/${value}`,
                                      style: {"font-family":"monospace"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($setup.formatPublicReference(value)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : _createCommentVNode("", true)
                              ]),
                              "item.actions": _withCtx(({ item }) => [
                                _createVNode(_component_v_btn, {
                                  icon: "mdi-minus",
                                  size: "small",
                                  color: "red",
                                  variant: "text",
                                  onClick: ($event: any) => ($setup.removeItem(item))
                                }, null, 8, ["onClick"])
                              ]),
                              _: 1
                            }, 8, ["items"]),
                            _createVNode(_component_v_btn, {
                              class: "mt-4",
                              color: "primary",
                              disabled: !$setup.itemsChanged || $setup.itemsSaving,
                              loading: $setup.itemsSaving,
                              onClick: $setup.saveBookingItems
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Foglalás elemek mentése")
                              ]),
                              _: 1
                            }, 8, ["disabled", "loading"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "mt-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Foglalás elem keresése")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: $setup.filters.accommodation,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters.accommodation) = $event)),
                                      label: "Szálláshely",
                                      variant: "outlined",
                                      density: "compact",
                                      clearable: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: $setup.filters.startDate,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.filters.startDate) = $event)),
                                      label: "Érkezés (tól)",
                                      type: "date",
                                      variant: "outlined",
                                      density: "compact",
                                      clearable: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: $setup.filters.endDate,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.filters.endDate) = $event)),
                                      label: "Távozás (ig)",
                                      type: "date",
                                      variant: "outlined",
                                      density: "compact",
                                      clearable: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_btn, {
                              color: "primary",
                              variant: "outlined",
                              onClick: $setup.searchBookingItems,
                              disabled: !$setup.canSearch
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Keresés")
                              ]),
                              _: 1
                            }, 8, ["disabled"]),
                            ($setup.searchResults.length > 0 || $setup.searched)
                              ? (_openBlock(), _createBlock(_component_v_data_table, {
                                  key: 0,
                                  class: "mt-4",
                                  headers: $setup.searchHeaders,
                                  items: $setup.searchResults,
                                  density: "compact",
                                  "no-data-text": "Nincs találat"
                                }, {
                                  "item.startDate": _withCtx(({ value }) => [
                                    _createTextVNode(_toDisplayString(value), 1)
                                  ]),
                                  "item.endDate": _withCtx(({ value }) => [
                                    _createTextVNode(_toDisplayString(value), 1)
                                  ]),
                                  "item.bookingPublicReference": _withCtx(({ value }) => [
                                    value
                                      ? (_openBlock(), _createBlock(_component_router_link, {
                                          key: 0,
                                          class: "text-decoration-none",
                                          to: `/admin/bookings/${value}`,
                                          style: {"font-family":"monospace"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.formatPublicReference(value)), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  "item.actions": _withCtx(({ item }) => [
                                    _createVNode(_component_v_btn, {
                                      icon: "mdi-plus",
                                      size: "small",
                                      color: "green",
                                      variant: "text",
                                      disabled: $setup.isAttached(item.id),
                                      onClick: ($event: any) => ($setup.addItem(item))
                                    }, null, 8, ["disabled", "onClick"])
                                  ]),
                                  _: 1
                                }, 8, ["items"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
}